import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const RepairStepMessage = ({ article }: { article: ArticleWithRelations }) => {
  if (
    article.step?.step === 'repair' &&
    article.step.config.startRepair?.enabled &&
    !article.repairStartedAt
  ) {
    return (
      <BaseMessage
        title={
          <Trans id="article.step-message.unstarted-repair.title">Pending start of repair</Trans>
        }
        message={
          <Trans id="article.step-message.unstarted-repair.message">
            The repair has not been started by the workshop yet.
          </Trans>
        }
        article={article}
      />
    );
  }

  return (
    <BaseMessage
      title={<Trans id="article.step-message.repair">The item is being repaired</Trans>}
      message={null}
      article={article}
    />
  );
};
